import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Home from './pages/Home';
import Agreement from './pages/Agreement';
import Admin from './pages/Admin';
import Customers from './pages/Customers';
import SignAgreement from './pages/SignAgreement';
import Hub from './pages/Hub';
import { useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import './App.css';

function Layout() {
  const location = useLocation();
  const { currentUser } = useAuth();

  const isHome = location.pathname === '/';
  const isSignPage = location.pathname.startsWith('/sign/');
  const isHubRoute = location.pathname === '/hub';

  // Sidebar replaces the public top navbar once the user is logged into
  // any internal module — it never shows on the home page or the
  // customer-facing signing page.
  const showSidebar = !isHome && !isSignPage && !!currentUser;
  const hideNavbar = isSignPage || isHubRoute || showSidebar;

  return (
    <>
      {!hideNavbar && <Navbar />}
      {showSidebar && <Sidebar currentUser={currentUser} />}
      <div className={`content ${showSidebar ? 'with-sidebar' : ''}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hub" element={<Hub />} />
          <Route path="/agreement" element={<Agreement />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/sign/:token" element={<SignAgreement />} />
        </Routes>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
}

export default App;
